/**
 * @generated SignedSource<<a7cb6a1307b35806c211dc90a76d4923>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type CompetitionEntitySubmissionStatusCompetitionFragment$data = {
  readonly event: {
    readonly event: {
      readonly slug: string;
    };
  };
  readonly id: string;
  readonly slug: string;
  readonly submission: {
    readonly id: string;
    readonly latest: {
      readonly id: string;
      readonly version: Semver;
      readonly " $fragmentSpreads": FragmentRefs<"SubmissionStatusBadgeFragment">;
    } | null | undefined;
    readonly maxEvaluation: {
      readonly projectVersion: {
        readonly id: string;
        readonly version: Semver;
        readonly " $fragmentSpreads": FragmentRefs<"SubmissionStatusBadgeFragment">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CompetitionEntitySubmissionStatusCompetitionFragment";
};
export type CompetitionEntitySubmissionStatusCompetitionFragment$key = {
  readonly " $data"?: CompetitionEntitySubmissionStatusCompetitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionEntitySubmissionStatusCompetitionFragment">;
};

import CompetitionEntitySubmissionStatusCompetitionQuery_graphql from './CompetitionEntitySubmissionStatusCompetitionQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = [
  (v0/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "SubmissionStatusBadgeFragment"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "owner"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionEntitySubmissionStatusCompetitionQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompetitionEntitySubmissionStatusCompetitionFragment",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "owner"
        }
      ],
      "concreteType": "EventCompetition",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            (v1/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Submission",
      "kind": "LinkedField",
      "name": "submission",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectVersion",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": (v2/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectVersionEvaluation",
          "kind": "LinkedField",
          "name": "maxEvaluation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectVersion",
              "kind": "LinkedField",
              "name": "projectVersion",
              "plural": false,
              "selections": (v2/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "7f159431266801a5dc410c33f462a580";

export default node;
